/**
 * Csv Schema of CargaTemp
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {CargaTemp} from '@/model/resource/CargaTemp'

/* TODO: review generated schema */
export class CsvCargaTempSchema extends Schema {
  readonly name = 'CsvCargaTemp'

  readonly fieldSet: FieldSet<CargaTemp> = {
    idCargaPk: schema => schema.model.idCargaPk,
  }
}
